<template lang="html">

  <section class="make-payment">
    <div class="pageHeading">
      <h1>Make A Payment</h1>
    </div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Select Traveler</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">Payment</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">Receipt!</v-stepper-step>

      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">


          <v-card
                  class="mb-5"
                  color=""
          >


            <h1>Select Traveler</h1>
            <br/>


            <v-container fluid>

            <v-radio-group v-model="selectedParticipant" :mandatory="false">
              <v-radio :value="participant" v-for="participant in  participants">
                <div  slot="label">
                  <strong>{{participant.fullName}}</strong> {{participant.Trip.prettyName}}
                  <span class="recommendedPayment">Recommended payment: {{participant.recommendedPayment}} <strong v-if="participant.totalFee > 0" style="color:darkred">*with late fee: ${{participant.totalFee}}</strong></span>
                </div>
              </v-radio>
              <v-divider inset></v-divider>
              <v-radio :value="participants" v-if="participants.length > 1">
                <div slot="label"> <strong>Pay All</strong> Applies payment evenly to all unpaid travelers
                </div>
              </v-radio>
              <v-divider inset></v-divider>
            </v-radio-group>

            </v-container>


          </v-card>


          <v-btn
                  color="primary"
                  @click="e1++"
          >
            Pay Now
          </v-btn>



        </v-stepper-content>

        <v-stepper-content step="2">

          <v-card
                  class="mb-5"
                  color=""
                  height=""
          >

            <v-timeline v-if="selectedParticipants != null"
                    dense
            >
              <v-timeline-item v-for="participantSelected in  selectedParticipants"
                               color="#1976d2"
                               small

              >
                <v-layout pt-3>
                  <v-flex xs6>
                    <strong>{{participantSelected.fullName}}</strong>
                    <br/>
                    <strong style="color:#1976d2">Payment Progress</strong>
                    <div class="caption"></div>
                  </v-flex>
                  <v-flex>
                    <div class="caption">

                      <span><strong>${{participantSelected.totalPaid + participantSelected.totalFundRaised}} paid/fundraising + ${{participantSelected.totalPending}} pending</strong> of ${{participantSelected.selectedTripCost}} trip total</span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>


            </v-timeline>


          </v-card>

          <v-layout justify-center>
            <v-flex xs12 sm10 md8 lg6>
              <payment-form v-if="selectedParticipants != null"
                            v-bind:maxPayment="maxPayment"
                            v-bind:initialPayment="intitialPayment"
                            v-bind:minPayment="minPayment"
                            v-bind:defaultMinPayment="defaultMinPayment"
                            v-bind:hidefr="true" v-on:alertUser="(result, message) => {this.$emit('alertUser', result, message);}"
                            v-bind:participant="selectedParticipants"></payment-form>

            </v-flex>
          </v-layout>


          <v-btn @click="e1--" flat>Previous</v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">

          <!--
          <h1>
            <i style="font-size: 100px;
    color: darkgreen;" class="material-icons">
              check_circle_outline
            </i>
          </h1>

          <h1>Congratulations, you are now paid in full and ready for your trip!</h1>
          <br>
          <p style="color: #881d1d;">Due to a price adjustment it looks like you have overpaid
            <br/>
          We will refund you the difference ($100) with 3 business days.</p>


          <v-btn @click="$router.push('/Payments')" color="secondary" dark>Payment History</v-btn>
          <v-btn
                  color="primary"
                  @click="$router.push('/')"
          >
            Back To Home
          </v-btn>
-->
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </section>

</template>

<script lang="js">

    import paymentForm from '../components/PaymentForm'
  export default  {
    name: 'make-payment',
      props: [],
      components: {
          paymentForm,
          CreditCardField: () => import(/* webpackChunkName: "vue-credit-card-field" */'vue-credit-card-field/src/Components/CreditCardField')
      },
    mounted() {
        this.billingName = this.$userData.firstName + ' ' +  this.$userData.lastName

        console.log('got user', this.$feathers.get('user'))
        var vueThis = this
        /*
        this.$services.participants.find().then((result) => {
            this.$services.payments.find().then((payments) => {


                console.log('participants result', result.data)
                if (result.data.length > 0) {
                    vueThis.tripLookup = result.data
                    result.data.forEach(function (participant) {
                        var toAdd = {
                            id: participant._id,
                            fullName: participant.firstName + " " + participant.lastName,
                        }

                    //    vueThis.$services.users.get(participant.UserID).then((userResult) => {

                            vueThis.$services.trips.get(participant.TripID).then((result) => {
                                console.log('get trip cost says', result)
                                var selectedPrice;

                                switch (participant.Occupancy) {
                                    case 1:
                                        selectedPrice = result.singlePrice
                                        break;
                                    case 2:
                                        selectedPrice = result.doublePrice
                                        break;
                                    case 3:
                                        selectedPrice = result.triplePrice
                                        break;
                                    case 4:
                                        selectedPrice = result.quadPrice
                                        break;

                                }

                                switch (participant.PaymentProgress) {
                                    case 0:
                                        toAdd.nextDueAmount = result.depositAmount
                                    case 1:
                                        toAdd.nextDue = result.firstPaymentDueDate
                                        toAdd.nextDueAmount = selectedPrice / 4
                                        break;
                                    case 2:
                                        toAdd.nextDue = result.secondPaymentDueDate
                                        break;
                                    case 3:
                                        toAdd.nextDue = result.thirdPaymentDueDate
                                        break;
                                    case 4:
                                        toAdd.nextDue = result.finalPaymentDueDate
                                        break;

                                }


                                toAdd.tripName = result.tripName
                                toAdd.tripID = result.tripID
                                toAdd.firstPaymentDueDate = result.firstPaymentDueDate
                                toAdd.secondPaymentDueDate = result.secondPaymentDueDate
                                toAdd.thirdPaymentDueDate = result.thirdPaymentDueDate
                                toAdd.finalPaymentDueDate = result.finalPaymentDueDate
                                toAdd.tripDeposit = Number(result.depositAmount)
                                toAdd.tripCost = Number(selectedPrice)
                                toAdd.paidAmount = 0

                                console.log('payments is', payments)
                                payments.data.forEach((payment)=> {
                                    if(payment.ParticipantID == toAdd.id) {
                                        toAdd.paidAmount += Number(payment.Amount)
                                    }
                                })

                                if(!participant.disabled)
                                vueThis.participants.push(toAdd)

                            })


                 //       })
                    });


                }
            })
        })
    */
    },
    data() {
      return {
          activePaymentType: 0,
         // participants: [],
          selectedParticipant: null,
          e1: 0,
          billingName: '',
          paymentAmount: 25,
          card: null,
          depositValue: 100,
          installment1: 100,
          installment2: 50,
          installment3: 0,
          installment4: 0
      }
    },
    methods: {
        alertUser(result, message) {
            this.$emit('alertUser', result, message)
        }

    },
    computed: {
        participants() {
            var toReturn = []
            this.$structuredData.participants.forEach((participant)=>{
                if(!participant.disabled && participant.percentPaid < 100) {
                    toReturn.push(participant)
                }
            })
            return toReturn
        },
        minPayment(){
            var toReturn = 0

            if(this.selectedParticipant != null)
            this.selectedParticipants.forEach((participant)=>{
                console.log('MIN---',participant.minPayment)
                toReturn = toReturn + Number(participant.minPayment)
            })
            return toReturn

        },
        defaultMinPayment(){
            var toReturn = 0
            if(this.selectedParticipant != null)
                this.selectedParticipants.forEach((participant)=>{
                    toReturn = toReturn + Number(participant.defaultMinPayment)
                })
            return toReturn
        },
        maxPayment() {
            var toReturn = 0

          console.log('selectedParticipant', this.selectedParticipant)

            if(this.selectedParticipant != null) {
              console.log('its not null')
              this.selectedParticipants.forEach((participant) => {
                toReturn = toReturn + Number(participant.maxPayment)
              })
            }
            return toReturn

        },
        intitialPayment() {
            var toReturn = 0
            if(this.selectedParticipant != null)
            this.selectedParticipants.forEach((participant)=>{
                var test = Number(participant.dueAmount) * this.selectedParticipants.length
                if(test > toReturn && test <= this.maxPayment) {
                    toReturn = test
                } else if (test > this.maxPayment) {
                    toReturn = this.maxPayment
                }
            })
            return toReturn

        },
        selectedParticipants(){
            if(this.selectedParticipant == null) {
                return null
            } else if (Array.isArray(this.selectedParticipant)) {
                return this.selectedParticipant
            } else {
                return [this.selectedParticipant]
            }
        }

    }
}
</script>

<style>

  .v-progress-linear__bar__determinate primary:after {
    content: "This is a fancy orange box.";
    background-color: #FFBA10;
    border-color: black;
    border-style: dotted;
  }


  .credit-card-field , .credit-card-field > .form-group {
    background-color: transparent !important;
  }

  .credit-card-field input {
    color: black !important;
  }
  .credit-card-field .credit-card-field-cvc {
    width: 20px !important;
  }


</style>

<style scoped lang="scss">

  .recommendedPayment {
    background-color: #a5a5a5ba;
    display: inline-block;
    border-radius: 15px;
    padding: 10px;
    margin: 5px;
  }
  .make-payment {

  }
  .paymentMeterBar {
    margin: 0;
  }
  .paymentMeterWrapper h3 {
    text-align: left;
  }
  .paymentMeterBar {
    width: 615px;
  }

</style>
